<template>
  <b-col sm="6" md="4" lg="3" class="text-center mb-3">

    <m-c11 :img="product.thumbnail">
      <template #p1>
        <m-h6 class="mr-2">{{ product.name }}</m-h6>

      </template>
      <template #p2>

        <b-row v-if="product.offer > 0">
          <b-col class="text-center">
            <b-card-text class="mt-3 text-center ">
              <del>
                <span class="m-auto text-center ml-auto mr-auto">{{ formatNumber(product.price) }} تومان</span>
              </del>
            </b-card-text>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center mb-2">
            <b-card-text class="mt-3 text-center ">
                <span class="m-auto text-center ml-auto mr-auto">{{ formatNumber(product.price-product.offer) }} تومان</span>
            </b-card-text>
          </b-col>
        </b-row>

      </template>

      <template #p3>
        <m-bt2 class=" mb-2" :href="{ name: 'Product', params: { name: product.raw_link } }">
          <span>مشاهده و خرید</span>
          <span class="mr-1"> <m-ic1 icon="cart" /> </span>
        </m-bt2>
      </template>


    </m-c11>


  </b-col>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProductCard",
  props: ["product"],
  methods: {
    formatNumber
  }
};
</script>

<style scoped>


</style>